import { render, staticRenderFns } from "./CardText.vue?vue&type=template&id=28433827&"
import script from "./CardText.vue?vue&type=script&lang=js&"
export * from "./CardText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports